document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open', !expanded);
    });
  });
  document.querySelectorAll('.waqt-lookbook__stage').forEach(function (stage) {
    var track = stage.querySelector('[data-carousel-track]');
    if (!track) return;
    ['prev', 'next'].forEach(function (direction) {
      var button = stage.querySelector('[data-carousel-' + direction + ']');
      if (!button) return;
      button.addEventListener('click', function () {
        var card = track.querySelector('.waqt-lookbook__card');
        var distance = card ? card.getBoundingClientRect().width + 14 : 400;
        track.scrollBy({ left: direction === 'next' ? distance : -distance, behavior: 'smooth' });
      });
    });
  });
  var select = document.querySelector('[data-variant-select]');
  var dataEl = document.getElementById('waqt-product-variants');
  if (select && dataEl) {
    try {
      var variants = JSON.parse(dataEl.textContent);
      select.addEventListener('change', function () {
        var variant = variants.find(function (v) { return String(v.id) === select.value; });
        if (!variant) return;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
        var addButton = document.querySelector('.waqt-product-form button[type="submit"]');
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'ADD TO CART →' : 'SOLD OUT';
        }
      });
    } catch (err) { /* Fallback to native variant select. */ }
  }
});


/* V11: Hover anywhere on the card. Short first advance, then steady looping.
   On exit retain the current photo and resume from it on re-entry. */
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.waqt-product-card,.waqt-collection-item').forEach(function(card){
    var frame=card.querySelector('.waqt-product-card__image,.waqt-collection-item__image');
    if(!frame)return;
    var slides=Array.from(frame.querySelectorAll('.waqt-card-slide'));
    if(slides.length<2)return;
    var index=0,timer=null,touchX=null,touchY=null;
    function show(next){index=(next+slides.length)%slides.length;slides.forEach(function(slide,i){slide.classList.toggle('is-active',i===index);slide.classList.toggle('is-inactive',i!==index);});}
    function stop(){if(timer!==null){clearTimeout(timer);timer=null;}}
    function advance(){show(index+1);timer=setTimeout(advance,3200);}
    function start(){if(!window.matchMedia('(hover: hover)').matches||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;stop();timer=setTimeout(advance,850);}
    card.addEventListener('mouseenter',start);
    card.addEventListener('mouseleave',stop);
    frame.addEventListener('touchstart',function(e){if(e.touches.length!==1)return;touchX=e.touches[0].clientX;touchY=e.touches[0].clientY;},{passive:true});
    frame.addEventListener('touchend',function(e){if(touchX===null||!e.changedTouches.length)return;var dx=e.changedTouches[0].clientX-touchX;var dy=e.changedTouches[0].clientY-touchY;if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)*1.2)show(index+(dx<0?1:-1));touchX=null;touchY=null;},{passive:true});
    card.addEventListener('focusin',stop);
    document.addEventListener('visibilitychange',function(){if(document.hidden)stop();});
  });
});
